/**
 * Viewer Variant — how the plan is rendered (orthogonal to the mode).
 *
 * A mode (INFO, ARRANGE, HOTSPOT, etc.) can be rendered in different ways:
 * - 2D (default orthographic projection)
 * - 3D (isometric or interactive 3D view)
 *
 * Not all modes support all variants; constraints are specified in the mode registry.
 */

export const VIEWER_VARIANT = {
  _2D: '2d',
  _3D: '3d',
}

export const VIEWER_VARIANT_LABEL_KEYS = {
  [VIEWER_VARIANT._2D]: 'product.viewer_2d',
  [VIEWER_VARIANT._3D]: 'product.viewer_3d',
}

/**
 * Default viewer variant
 */
export const VIEWER_VARIANT_DEFAULT = VIEWER_VARIANT._2D

/**
 * All available viewer variants
 */
export const ALL_VIEWER_VARIANTS = Object.values(VIEWER_VARIANT)
